import Logger from '../modules/logger';

function runWidgets(widgets) {
  widgets.forEach((widget) => {
    new Promise((resolve) => {
      widget.initialize();
      resolve();
    })
    .catch((error) => {
      const logger = Logger.get();

      logger.error(`Something went wrong during "${widget.name}" widget initialization`, error);
    });
  })
}

export default runWidgets;
